module.exports = __webpack_public_path__ + "sygnet-light.png?da97e54e01de2db9eda2fb10b9b0fa31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/sygnet-light.png
// module id = 974
// module chunks = 2